<div *ngIf="(evaluation$ | async)" [hidden]="hidden$ | async">
  <hr />
</div>
